import { render, staticRenderFns } from "./TipWidget.vue?vue&type=template&id=988ab034&scoped=true&"
import script from "./TipWidget.vue?vue&type=script&lang=js&"
export * from "./TipWidget.vue?vue&type=script&lang=js&"
import style0 from "./TipWidget.vue?vue&type=style&index=0&id=988ab034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988ab034",
  null
  
)

component.options.__file = "TipWidget.vue"
export default component.exports